import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function InteractionPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const page = localStorage.getItem('page');
  const id = localStorage.getItem('pageId');
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('AirswiftAccessToken');
    if (isAuthenticated?.length) {
      navigate(`/dashboard/${page}/${id}`);
      if (!page && !id) {
        navigate('/dashboard');
      }
    }

    if (!page && !id) {
      navigate('/');
    }
  }, [searchParams]);
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress sx={{ height: '8px' }} />
    </Box>
  );
}
